module.exports = __webpack_public_path__ + "img/about_73.5ad30655.png";